import { useEffect, useState } from "react";
import bannerLogo from '../../assets/images/CLUBEZ_Login_logo.png';
import ImageCropper from '../global/imageCropper';
import * as helper from "../global/helper";
import './membershipForm.css';
import AddDocument from "../global/addDocument";
import agreementFromList from './agreementFroms.js'; 
import FormFooter from './formFooter.js'; 
import PrimaryForm from "./primaryForm.js";
import MemberForm from "./memberForm.js";
import Reference from "./reference.js";
import NominationForm from "./nominationForm.js";
import swal from 'sweetalert2';
import Swal from 'sweetalert2';
import { getOnboardingDataByGroupID, postOnboardingData, uploadPrivateFile, uploadPublicFile } from "../api/onboardingAPI.js";
import { useHistory } from 'react-router-dom';

const MembershipForm = (props) => {

    const [primaryDetails,              setPrimaryDetails]              = useState({MemberType: 'Primary'});
    const [primaryPhotoBlob,            setPrimaryPhotoBlob]            = useState(null);
    const [signaturePhotoBlob,          setSignaturePhotoBlob]          = useState(null);

    const [spouseDetails,               setSpouseDetails]               = useState({MemberType: 'Spouse'});
    const [spousePhotoBlob,             setSpousePhotoBlob]             = useState(null);
    
    const [groupDetails,                setGroupDetails]                = useState({});

    const [memberList,                  setMemberList]                  = useState(Array(groupDetails?.Child).fill({MemberType: 'Child'}));
    const [memberPhotoBlobs,            setMemberPhotoBlobs]            = useState(Array(groupDetails?.Child).fill(null));

    const [reference1Details,           setReference1Details]           = useState({});
    const [reference2Details,           setReference2Details]           = useState({});

    const [adminDetails,                setAdminDetails]                = useState({});

    const [membershipPhotoBlob,         setMembershipPhotoBlob]         = useState(null);
    const [adminPhotoBlob,              setAdminPhotoBlob]              = useState(null);
  
    const [cropperData,                 setCropperData]                 = useState(null);
    const [signatureCropperData,        setSignatureCropperData]        = useState(null);
    const [addDocument,                 setAddDocument]                 = useState(false);
    const [editDocument,                setEditDocument]                = useState(null);
    const [documentDetails,             setDocumentDetails]             = useState({});
    const [document,                    setDocument]                    = useState([]);
    const [formValidList ,              setFormValidList]               = useState([]);
    const [accessDetails,               setAccessDetails]               = useState({});
    const [panError,                    setPanError]                    = useState('');
    const [urlUserID,                   setUrlUserID]                   = useState('');
    const [urlID,                       setUrlID]                       = useState('');
 
    const history = useHistory();
   
    useEffect(() => {
        if(accessDetails.AdminType == 'Admin' && !!adminDetails.AdminSignature){
            window.open(`https://demo.clubez.inuser-onboarded?userName=${primaryDetails.FirstName + ' ' + primaryDetails.LastName}&type=${groupDetails.MembershipType}`, '_blank', 'noopener');
        };
    },[accessDetails, adminDetails])
 
    useEffect(() => {
        const queryParameters = new URLSearchParams(window.location.search);
        const groupIDValue = queryParameters.get("id");
        let userIDValue = queryParameters.get("userID");

        if (groupIDValue && userIDValue) {
            setUrlID(groupIDValue)
            setUrlUserID(userIDValue)
            fetchOnboardingDetails(groupIDValue, userIDValue);
            queryParameters.delete("userID"); 
        } else {
            Swal.close();
            Swal.fire({
                icon: "error",
                titleText: "Error: Form not found",
                showConfirmButton: false,
                allowOutsideClick: false
            });
        }
    }, [history]);

    useEffect(() => {
        if(Object.keys(documentDetails).length != 0){
            setDocument((a) => {
                const filterA = documentDetails.Index  >= 0 ? a.filter((c, i) => i != documentDetails.Index) : a;
                const newA = [...filterA];
                newA.push((documentDetails))
                return newA
            })
        }
    },[documentDetails])
 
    useEffect(() => {
        updateFormValidity(); 
    }, [groupDetails, primaryDetails, spouseDetails, memberList, primaryPhotoBlob, spousePhotoBlob, memberPhotoBlobs, document]);
 
    useEffect(() => {
        if (groupDetails.PanNo) {
          if (validatePAN(groupDetails.PanNo)) {
            setPanError('');
          } else {
            setPanError('Invalid PAN card. Please enter a valid PAN.');
          }
        } else {
          setPanError('');
        }
    }, [groupDetails.PanNo]);
   
    const validatePAN = (pan) => {
        const panPattern = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
        return panPattern.test(pan);
      };

    const fetchOnboardingDetails = async (groupID, userID) => {
         try {
            Swal.fire({
                titleText           : 'Loading',
                text                : 'Please Wait...',
                showConfirmButton   : false,
                allowOutsideClick   : false,
                onOpen: () => {
                    Swal.showLoading();
                }
            });
             const response = await getOnboardingDataByGroupID(groupID, userID);

            const primaryUser = response?.User.find(f => f.MemberType === "Primary") || {MemberType: 'Primary'};
            const spouseUser = response?.User.find(f => f.MemberType === "Spouse") || {MemberType: 'Spouse'};
            const memberList = response?.User.filter(({ MemberType }) => MemberType === "Child");
            const childList = memberList.length ? memberList : Array(response?.Group?.Child || 0).fill({ MemberType: 'Child' });

            props.setSignatureImg(response?.Group?.MemberSignature)
            setPrimaryDetails(primaryUser);
            setSpouseDetails(spouseUser);
            setMemberList(childList);
            setReference1Details(response?.Reference[0] || {});
            setReference2Details(response?.Reference[1] || {});
            setAdminDetails(response?.Admin || {});
            setGroupDetails(response?.Group);
            setDocument(response?.Document);
            setAccessDetails(response?.Access);
            ///
            Swal.close();
        } catch (err) {
            Swal.close();
            Swal.fire({
                icon              : "error",
                titleText         : err.message,
                showConfirmButton : false,
                allowOutsideClick : false
            })
            return;  
        }
    }

    /////////////////////////////////////////// --FormValidator--///////////////////////////////////////////////////////////////////

    const getEmptyFieldsForObject = (obj, requiredFields, prefix = '') => { // Function to get empty fields for an object based on required fields
        const emptyFields = [];
        requiredFields.forEach(field => {
            if (!obj[field]) {
                emptyFields.push(prefix + field);
            }
        });
        return emptyFields;
    };

    const getEmptyFields = () => { // Function to check if all form fields are empty and return list of empty fields
        const emptyFields = [];

        // Check groupDetails
        const groupDetailsRequiredFields = [ 'Address', 'PanNo'];
        emptyFields.push(...getEmptyFieldsForObject(groupDetails, groupDetailsRequiredFields));
        if (groupDetails.Category === 'Organization' && !groupDetails.CompanyName) {
            emptyFields.push('Company Name');
        }
        if (!groupDetails.MemberSignature && !signaturePhotoBlob) {
            emptyFields.push('Signature');
        }

        // Check primaryDetails
        const primaryDetailsRequiredFields = ['FirstName', 'LastName', 'DOB', 'Gender', 'Email', 'Mobile', 'BloodGroup', 'AadharCardNo'];
        emptyFields.push(...getEmptyFieldsForObject(primaryDetails, primaryDetailsRequiredFields));
        if (!primaryDetails.ProfilePhoto && !primaryPhotoBlob) {
            emptyFields.push('Primary Details: Profile Photo');
        }

        // Check spouseDetails
        const spouseDetailsRequiredFields = ['FirstName', 'LastName', 'DOB', 'Gender', 'Email', 'Mobile', 'BloodGroup', 'AadharCardNo'];
        emptyFields.push(...getEmptyFieldsForObject(spouseDetails, spouseDetailsRequiredFields,'Spouse: '));
        if (!spouseDetails.ProfilePhoto && !spousePhotoBlob) {
            emptyFields.push('Spouse Details: Profile Photo');
        }

        // Check memberList
        memberList.forEach((member, index) => {
            const memberRequiredFields = ['FirstName', 'LastName', 'DOB', 'Gender', 'Email', 'Mobile', 'BloodGroup'];
            const memberEmptyFields = getEmptyFieldsForObject(member, memberRequiredFields, `Child ${index + 1}: `);
            emptyFields.push(...memberEmptyFields);
            if (!member.ProfilePhoto && !memberPhotoBlobs[index]) {
                emptyFields.push(`Child ${index + 1}: Profile Photo`);
            }
        });

        // Custom validation for document array
        if (!document || document.length === 0) {
            emptyFields.push('Document');
        }

        return emptyFields;
    };

    // Function to update form validity state
    const updateFormValidity = () => {
        const emptyFields = getEmptyFields();
        setFormValidList(emptyFields);
    };

    ///////////////////////////////////////// --FormValidator--///////////////////////////////////////////////////////////////////
 
    const removeDocHandler = async(index) => {
        setDocument((a) => {
            const nA = a.filter((b, i) => index !== i);
            return nA;
        });
	};  

    const updatePrimaryDetails = (field, value) => { 
        setPrimaryDetails((d) => {
            return { ...d, [field]: value };
        });
    };

    const updateSpouseDetails = (field, value) => { 
        setSpouseDetails((d) => {
            return { ...d, [field]: value };
        });
    };

    const updateReference1Details = (field, value) => { 
        setReference1Details((d) => {
            return { ...d, [field]: value };
        });
    };

    const updateReference2Details = (field, value) => { 
        setReference2Details((d) => {
            return { ...d, [field]: value };
        });
    };

    const updateAdminDetails = (field, value) => { 
        setAdminDetails((d) => {
            return { ...d, [field]: value };
        });
    };

    const updateGroupDetails = (field, value) => { 
        setGroupDetails((d) => {
            return { ...d, [field]: value };
        });
    };
 
    // Function to update state member by index
    const updateArrayState = (setStateFunc, index, key, newValue) => {
        setStateFunc(prevState => {
            const newState = [...prevState];
            newState[index] = { ...newState[index], [key]: newValue, Index: index };
            return newState;
        });
    };

    // function to update photo state by index
    const updateArrayStatePhoto = (setStateFunc, index, newValue) => {
        setStateFunc(prevState => {
            const newState = [...prevState];
            newState[index] = {newValue, Index: index};
            return newState;
        });
    };


    const saveForm = async(e) => {
 
        e.preventDefault();
        try {
            swal.fire({
                titleText           : 'Loading',
                text                : 'Please Wait...',
                showConfirmButton   : false,
                allowOutsideClick   : false,
                onOpen: () => {
                    swal.showLoading();
                }
            });
  
            // user
            const userList = await Promise.all([...memberList, primaryDetails, spouseDetails].map(async (m, i) => {
                let profilePhotoBlob;
                
                switch (m.MemberType) {
                    case 'Primary':
                        profilePhotoBlob = primaryPhotoBlob;
                        break;
                    case 'Spouse':
                        profilePhotoBlob = spousePhotoBlob;
                        break;
                    default:
                        profilePhotoBlob = memberPhotoBlobs.find(f => f?.Index === i)?.newValue || '';
                }
                let userPhoto = '';
                if (profilePhotoBlob) {
                    const res = await uploadPublicFile(profilePhotoBlob, 'User');
                    userPhoto = res.fileName;
                }else{
                    if(m.ProfilePhoto) userPhoto = m.ProfilePhoto.split('/User/')[1];
                }
            
                return {
                    ID:             m?.ID,
                    MemberType:     m.MemberType,
                    FirstName:      m.FirstName,
                    MiddleName:     m.MiddleName,
                    LastName:       m.LastName,
                    DOB:            m?.DOB,
                    Gender:         m.Gender,
                    Email:          m.Email,
                    Mobile:         m.Mobile,
                    BloodGroup:     m.BloodGroup,
                    AadharCardNo:   m.AadharCardNo,
                    School:         m.School,
                    ProfilePhoto:   userPhoto
                };
            }));
            
            // documents
            let documentList = [];
            for (const m of document) {
                let userDoc = '';
                //Call upload API -->
                if(m.Document && m.Document != ''){
                    const res = await uploadPrivateFile(m.Document, 'Document');
                    userDoc = res.fileName;            
                }else{
                    if(m.FileName) userDoc = m.FileName;
                }

                documentList.push({
                    ID:              m?.ID,
                    DocumentType:    m.DocumentType,
                    FileName:        userDoc
                })
            };

            // admin
            const photoBlobs = [
                { blob: membershipPhotoBlob, key: 'MembershipSignature' },
                { blob: adminPhotoBlob, key: 'AdminSignature' }];

            const uploadPromises = photoBlobs.map(async ({ blob, key }) => {
                if (blob) {
                    const res = await uploadPublicFile(blob, 'User');
                    adminDetails[key] = res.fileName;
                }else{
                    if(adminDetails[key]) adminDetails[key] = adminDetails[key].split('/User/')[1];

                }
            });
            
            await Promise.all(uploadPromises);
             
            // group
            if (signaturePhotoBlob) {
                const res = await uploadPublicFile(signaturePhotoBlob, 'User');
                groupDetails.MemberSignature = res.fileName;
            }else{
                if(groupDetails.MemberSignature) groupDetails.MemberSignature = groupDetails.MemberSignature.split('/User/')[1];

            }
            
             await postOnboardingData(userList, groupDetails, adminDetails, documentList, [reference1Details, reference2Details], accessDetails, formValidList.length > 0 ? "N" : "Y")
 
            if(!!adminDetails.PresidentSignature){
                swal.fire({
                    icon: 'success',
                    titleText: `User has been Onboarded Succesfully.`,
                    showConfirmButton: false,
                    timer: 3000,
                });

            }
            swal.close();
            
            setMembershipPhotoBlob(null);
            setAdminPhotoBlob(null);  
            setMemberPhotoBlobs(Array(groupDetails?.Child).fill(null));
            setSpousePhotoBlob(null);
            setSignaturePhotoBlob(null);
            setPrimaryPhotoBlob(null);

            fetchOnboardingDetails(urlID, urlUserID);
                
        } catch (err) {
            swal.fire({
                icon                  : 'error',
                titleText             : 'Error!',
                text                  : err.message,
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',
            }); 
        }
    };

    const openDocument = async (d) => {
        if(!!d?.FileName){
            const ext = helper.getFileExt(d?.FileName)
            const name = (d.DocumentType + '.' + ext).replace(/ /g, '_');
            helper.downloadAndOpenFileHandler('Document', d.FileName, name); 
        }
    };

    ///////////////////////// Button Validation /////////////////////////


    const isDisabled = () => {
        const adminID = accessDetails.AdminID;
         const conditions = [
            { id: 1, blob: membershipPhotoBlob, signature: adminDetails.MembershipSignature },
            { id: 2, blob: adminPhotoBlob, signature: adminDetails.AdminSignature },
        ];
    
        return conditions.find(f => (f.id == adminID &&  !(!!f.blob || f.signature)))
 
    };
    
    const isAdminDisabled = (adminID, adminDetails) => {        
        return (adminID == 0 && formValidList.length > 0) ||
               (adminID == 1 && !adminDetails.MembershipSignature) ||
               (adminID == 2 && !adminDetails.AdminSignature);
    };
    
    const getButtonText = (adminID, adminDetails) => {
        if (adminID == 0) return "Save & Submit";
        if ( (adminID == 1 && adminDetails.MembershipSignature) ||
            (adminID == 2 && adminDetails.AdminSignature)) {
            return "Save";
        }
        return "Approve";
    };

    return (
        <>
            <div className={`container ${(groupDetails.IsSubmit == "Y" && accessDetails.AdminID == 0) || (!!adminDetails.PresidentSignature) ? 'disabled-overlay' : ''} inputMemberForm`} style={{width: '1000px'}}>
                <form className="form-horizontal">
                    {/* Primary */}
                    <PrimaryForm 
                        setSignatureImg={props.setSignatureImg} 
                        primaryDetails={primaryDetails} 
                        updatePrimaryDetails={updatePrimaryDetails}
                        setPrimaryPhotoBlob={setPrimaryPhotoBlob}
                        primaryPhotoBlob={primaryPhotoBlob}
                        setSignaturePhotoBlob={setSignaturePhotoBlob}
                        signaturePhotoBlob={signaturePhotoBlob}
                        groupDetails={groupDetails}
                        updateGroupDetails={updateGroupDetails}
                        panError={panError}
                     />
                    
                    {/* Spouse */}
                    <MemberForm 
                        memberDetails={spouseDetails} 
                        updateMemberDetails={updateSpouseDetails}
                        setMemberPhotoBlob={setSpousePhotoBlob}
                        memberPhotoBlob={spousePhotoBlob}
                        memberType={"Spouse Details"}
                        pageCount={2}
                    />  

                    {/* Child Details */}

                    {Array.from({ length: groupDetails?.Child }, (_, index) => (
                        <MemberForm
                            key={index}
                            memberDetails={memberList[index]}
                            updateMemberDetails={(key, newValue) => updateArrayState(setMemberList, index, key, newValue)}
                            setMemberPhotoBlob={(newBlob) => updateArrayStatePhoto(setMemberPhotoBlobs, index, newBlob)}
                            memberPhotoBlob={memberPhotoBlobs[index]?.newValue}
                            memberType={`Child-${index + 1} Details`}
                            pageCount={index + 3}
                        />
                    ))}

                    {/* Document Upload */}
                    <div className="panel panel-paper">
                        <div className="panel-body form-onboarding">
                            <div className="panel-heading text-center" style={{marginBottom: '20px'}}>
                                {/* Logo and club name */}
                                <img className="img-responsive img-login margin-b10" src={bannerLogo} alt="" style={{height: '80px'}}/>
                                <h3 className="panel-title mb-0 padding-t0"><strong>MEMBERSHIP AGREEMENT</strong></h3>
                            </div>
                            <fieldset className="child-3">
                                <legend> Document Upload (<small>e.g. Pan Card, Aadhaar Card</small>)</legend>
                                <div className="text-center">
                                    <button type="button" className="btn btn-default upload-button" style={{width: "170px", height: "35px" }} onClick={() => setAddDocument(true)}> Upload Document</button>
                                </div>
                                <div className="row margin-tb50">
                                    {document.length > 0 && document.map((d, i) => (
                                        <div className="col-12 col-sm-3 padding-10 text-center" key={i}>
                                            {/* Edit button */} 
                                            <div className="edit-doc" onClick={() => setEditDocument({...d, Index: i})}>
                                                <div className="pencil-container">
                                                    <i className="fa fa-pencil"></i>
                                                    <span className="add-text">Update</span>
                                                </div>
                                            </div>
                                            <img height="100px" width="100px" src={helper.getFileLogo(d?.Document?.name || d?.FileName)}   onClick={() => openDocument(d)}/>
                                            <h6>{d.DocumentType}</h6>
                                            <span className="doc__cancel" onClick={() => removeDocHandler(i)}>
                                                <div className="pencil-container">
                                                    <i className="fa fa-times"></i>
                                                    <span className="add-text">Delete</span>
                                                </div>
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </fieldset>
                        </div>
                        <FormFooter num={groupDetails.Child + 3} />
                    </div>

                    {/* Forms */}
                    {agreementFromList.length > 0 && agreementFromList.map((m, i) => (
                        <div className="panel panel-paper" key={i}>
                            <div className="panel-body form-onboarding" >
                                <div className="panel-heading text-center"  >
                                    {/* Logo and club name */}
                                    <img className="img-responsive img-login margin-b10" src={bannerLogo} alt="" style={{height: '80px'}}/>
                                    <h3 className="panel-title mb-0 padding-t0"><strong>MEMBERSHIP AGREEMENT</strong></h3>
                                </div>
                                <fieldset className="child-3" style={{marginTop: '20px'}}>
                                    <legend style={{marginBottom: '10px'}}> </legend>
                                    <div dangerouslySetInnerHTML={{ __html: m }} />
                                </fieldset>
                            </div>
                            <FormFooter num={groupDetails.Child + 4 + i} />
                        </div>
                    ))};

                    {/* REFERENCES */}
                    <Reference 
                        reference1Details={reference1Details} 
                        reference2Details={reference2Details} 
                        updateReference1Details={updateReference1Details}
                        updateReference2Details={updateReference2Details}
                    />
 
                    {/* Nomination */}
                    <NominationForm 
                        setMembershipPhotoBlob={setMembershipPhotoBlob}
                        membershipPhotoBlob={membershipPhotoBlob}
                        setAdminPhotoBlob={setAdminPhotoBlob}
                        adminPhotoBlob={adminPhotoBlob}
                        groupDetails={groupDetails}
                        updateGroupDetails={updateGroupDetails}
                        updateAdminDetails={updateAdminDetails}
                        adminDetails={adminDetails}
                        primaryDetails={primaryDetails}
                        accessDetails={accessDetails}

                    />  
                </form>
                <nav className="navbar navbar-default navbar-fixed-bottom" style={{boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.3)"}}>
                    <div className="container-fluid">
                        <form className="navbar-form navbar-right" role="search">
                            {formValidList.length > 0 ? (
                                <>
                                    <button type="save" className="btn btn-default margin-r10" onClick={saveForm}>Save</button>
                                    <div className="tooltip-wrapper">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={formValidList.length > 0}
                                        >
                                            Submit
                                        </button>
                                        <div className="tooltip-container">
                                            <div className="tooltip-inner">
                                            <p>Please complete the following fields:</p>
                                            <p>{formValidList.join(', ')}</p>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ): (
                                <div className="tooltip-wrapper">
                                    <span className="padding-r10">
                                        {(groupDetails.IsSubmit == "Y" && accessDetails.AdminID == 0) && 'Your form has been submitted successfully and is in the process of verifying'}
                                    </span>
                                    <button
                                        disabled={ isDisabled() }
                                        type="submit"
                                        className={`btn btn-${isAdminDisabled(accessDetails.AdminID, adminDetails) ? "danger" : "primary"}`}
                                        onClick={saveForm}
                                    >
                                        {getButtonText(accessDetails.AdminID, adminDetails)}
                                    </button>
                                </div>
                             )}
                        </form>
                    </div>
                </nav>
            </div>
            {cropperData && (
                <ImageCropper
                    show           = { cropperData }
                    header         = { cropperData.header }   
                    imageRatio     = { cropperData.imageRatio }
                    dataHandler    = { cropperData.dataHandler }
                    onDismissModal = {() => setCropperData(null) }
                />
            )}
            {signatureCropperData && (
                <ImageCropper
                    show           = { signatureCropperData }
                    header         = { signatureCropperData.header }   
                    imageRatio     = { signatureCropperData.imageRatio }
                    dataHandler    = { signatureCropperData.dataHandler }
                    onDismissModal = {() => setSignatureCropperData(null) }
                />
            )}
            {(addDocument || editDocument) && (
                <AddDocument
                    show={addDocument}
                    onDismissModal={setAddDocument}
                    editDocument={editDocument || ''}                                    
                    setEditDocument={setEditDocument}                                    
                    setDocumentDetails={setDocumentDetails}                                    
                />
            )}
        </>
    );
};

export default MembershipForm;